import { IBlock } from "../../../framework/src/IBlock";
import { BlockComponent } from "../../../framework/src/BlockComponent";
import MessageEnum, {
    getName
} from "../../../framework/src/Messages/MessageEnum";
import { runEngine } from "../../../framework/src/RunEngine";
// Customizable Area Start
// Customizable Area End

export const webConfigJSON = require("./config.js");

export interface Props {
    navigation: any;
    // Customizable Area Start
    checked: boolean
    // Customizable Area End
}
interface S {
    // Customizable Area Start

    // Customizable Area End
}
interface SS { }

export default class RevenueController extends BlockComponent<Props, S, SS> {
    // Customizable Area Start

    constructor(props: Props) {
        super(props);
        this.receive = this.receive.bind(this);

        this.subScribedMessages = [
            getName(MessageEnum.RestAPIResponceMessage),
        ];

        this.state = {};

        runEngine.attachBuildingBlock(this as IBlock, this.subScribedMessages);
    }

    navigateToEarnigs = () => {
        this.props.navigation.navigate("Earnings");
    }
    // Customizable Area End
}
